import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Flex } from '@chakra-ui/react';
import Sidebar from '../../components/global/sideBar';
import Header from '../../components/provider/header';
import JobList from '../../components/provider/JobList';
import PostJobComponent from './createJob';
import Dashboard from '../../components/provider/AnalyticCard';
import MyProfile from './MyProfile';
import Settings from '../../components/global/settings';
import JobManagement from '../../components/provider/jobListTable'; // Import the JobManagement component
import HistoryTable from '../../components/provider/history'; // Import the HistoryTable component
import PrivacyPolicy from '../../components/provider/privacyPolicy'; // Import the PrivacyPolicy component
import ViewJob from '../../components/provider/viewJob'; // Import the ViewJob component
import ApplicantProfile from '../../components/provider/applicantProfile';
import CertificatesComponent from '../../components/provider/documents';
import GetHelpPage from '../../components/provider/getHelp';
import { ChakraProvider } from '@chakra-ui/react';

const ProviderHome = () => {
  const [selectedView, setSelectedView] = useState('home');
  const [profileSubView, setProfileSubView] = useState('personalInfo');
  const ticketToken = sessionStorage.getItem('ticketToken');
  const [selectedJob, setSelectedJob] = useState(null); // State to track the selected job
  const [selectedApplicant, setSelectedApplicant] = useState(null); // State to track the selected applicant

  const [homePageData, setHomePageData] = React.useState({
    avatarSrc: '',
    fullName: '',
    userName: '',
    licenseId: '',
    password: '',
    email: '',
    contactNumber: '',
    bio: '',
    address: '',
    specialties: '',
    services: '',
    organizationType: '',
    accreditations: '',
    role: '',
    countryCode: '',
    street: '',
    city: '',
    state: '',
    country: '',
    pinCode: '',
    individualIdentity: '',
    agencyDetails: {
      licenseId: '',
      certification: '',
      certificationExpiry: '',
      issuingAuthority: ''
    },
    organizationalSpecialization: ''
  });
  React.useEffect(() => {
    const fetchHomePageData = async () => {
      //const ticketToken = sessionStorage.getItem('ticketToken');
      const ticketToken = sessionStorage.getItem('ticketToken');
      if (!ticketToken) {
        console.error('No ticket token found in sessionStorage');
        return;
      }
      console.log('Ticket Token:', ticketToken);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/provider/get-homepage-details`,
          {
            headers: {
              Authorization: `Bearer ${ticketToken}`
            }
          }
        );
        console.log('Response data:', response.data); // Log the response data

        // Update to match the response structure
        setHomePageData({
          fullName: response.data.data.FullName || '',
          email: response.data.data.email || '',
          role: response.data.data.role || '',
          countryCode: response.data.data.country_code || '',
          street: response.data.data.address?.street || '',
          city: response.data.data.address?.city || '',
          state: response.data.data.address?.state || '',
          country: response.data.data.address?.country || '',
          individualIdentity: response.data.data.individual_identity || '',
          agencyDetails: {
            licenseId: response.data.data.agencyDetails?.licenseId || '',
            certification: response.data.data.agencyDetails?.certification || '',
            certificationExpiry: response.data.data.agencyDetails?.certificationExpiry || '',
            issuingAuthority: response.data.data.agencyDetails?.issuingAuthority || ''
          },
          organizationType: response.data.data.organization_type || '',
          organizationalSpecialization: response.data.data.organizational_specialization || '',
          bio: response.data.data.bio || ''
        });
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchHomePageData();
  }, []);



  useEffect(() => {
    if (selectedView === 'profile') {
      setProfileSubView('personalInfo');
    }
  }, [selectedView]);
  

  const renderContent = () => {
    
    if (selectedApplicant) {
      return <ApplicantProfile applicant={selectedApplicant} onBack={() => setSelectedApplicant(null)} />; // Pass applicant and onBack function
    }

    if (selectedJob) {
      return <ViewJob jobId={selectedJob} onBack={() => setSelectedJob(null)} onViewApplicant={setSelectedApplicant} />; // Pass onViewApplicant function
    }

    switch (selectedView) {
      case 'home':
        return (
          <>
            <Box flexShrink={0} width="100%" mb={4}>
              <PostJobComponent />
            </Box>
            <Box flex="1" display="flex" width="100%" justifyContent="space-between" alignItems="flex-start">
              <Box
                flex="3"
                height="100%"
                maxHeight="65vh"
                overflowY="auto"
                p={2}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                mt={2}
              >
                <JobList />
              </Box>
              <Box
                flex="1"
                height="100%"
                maxHeight="65vh"
                overflowY="auto"
                p={2}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                mt={2}
              >
                <Dashboard />
              </Box>
            </Box>
          </>
        );
      // case 'profile':
      //   return <MyProfile selectedSection={profileSubView} />;
      case 'profile':
        switch (profileSubView) {
          case 'personalInfo':
            return <MyProfile initialFullName={homePageData.fullName || ''} initialEmail={homePageData.email || ''} initialRole={homePageData.role || ''} />;
          case 'certificates':
            return <CertificatesComponent />;
          case 'privacy':
            return (
              <Box
                height="100%"
                maxHeight="calc(100vh - 60px)" // Adjust based on your header height
                overflowY="auto" // Enable scrolling for the privacy policy section
                p={4}
                bg="white"
                boxShadow="md"
                borderRadius="lg"
                mt={2}
              >
                <PrivacyPolicy />
              </Box>
            );
          default:
            return null;
        }
  
      case 'settings':
        return <Settings />;
      case 'jobManagement': // Add a new case for jobManagement
        return <JobManagement onViewJob={setSelectedJob} />; // Pass the setSelectedJob function
      case 'history': // Add a new case for history
        return <HistoryTable />;
        case 'help':
          return <GetHelpPage />;
      default:
        return null;
    }
  };

  return (
    <ChakraProvider>
      <Flex height="100vh" overflow="hidden">
        <Sidebar
          onSelectItem={setSelectedView}
          selectedItem={selectedView}
          onSelectProfileSubView={setProfileSubView}
        />
        <Box flex="1" ml="250px" display="flex" flexDirection="column" height="100vh">
          <Box>
            <Header height="60px" />
          </Box>
          <Box flex="1" p={4} overflow="hidden" display="flex" flexDirection="column"  width="100%">
            {renderContent()}
          </Box>
        </Box>
      </Flex>
    </ChakraProvider>
  );
};

export default ProviderHome;